import React from 'react';
import { Icon } from '../icon';
import type { IconProps } from '../icon-props';

export function IconChecked(props: IconProps) {
  return (
    <Icon {...props}>
      <path fill='none' d='M0 0h256v256H0z' />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={16}
        d='m172 104-58.7 56L84 132'
      />
    </Icon>
  );
}
